import { render, staticRenderFns } from "./ItemsTableTransfer.vue?vue&type=template&id=656d157e&scoped=true"
import script from "./ItemsTableTransfer.vue?vue&type=script&lang=js"
export * from "./ItemsTableTransfer.vue?vue&type=script&lang=js"
import style0 from "./ItemsTableTransfer.vue?vue&type=style&index=0&id=656d157e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656d157e",
  null
  
)

export default component.exports